import {
  type ModalController,
  type ModalHookContext,
  setupModalCommands,
  syncModalAccessibleName
} from './modal'

// Private types ---------------------------------------------------------------

type DialogHookContext = ModalHookContext & {
  modalController?: ModalController
}

// Public hook -----------------------------------------------------------------

export const FacadeDialog = {
  // Creates the visibility controller for this dialog instance.
  mounted(this: DialogHookContext) {
    this.modalController?.cleanup()
    this.modalController = setupModalCommands(this, 'dialog')
  },

  // Reconciles runtime state after a LiveView patch.
  updated(this: DialogHookContext) {
    this.modalController?.sync()
    syncModalAccessibleName(this.el)
  },

  // Releases controller listeners when LiveView removes the dialog.
  destroyed(this: DialogHookContext) {
    this.modalController?.cleanup()
    this.modalController = undefined
  }
}
